import {
  ADD_FARM_TO_FAVOURITES_SERVICE_URL,
  GET_FAVORITE_FARMS_SERVICE_URL,
  REMOVE_FARM_FROM_FAVOURITES_SERVICE_URL,
} from './config';
import axiosInstance from '../axiosInstance';

export const api = {
  async addFarmToFavourites(farmIdToBeAddedToFavourites) {
    return axiosInstance.post(
      `${ADD_FARM_TO_FAVOURITES_SERVICE_URL}${farmIdToBeAddedToFavourites}`,
    );
  },
  async removeFarmFromFavourites(farmIdToBeRemovedFromFavourites) {
    return axiosInstance.delete(
      `${REMOVE_FARM_FROM_FAVOURITES_SERVICE_URL}${farmIdToBeRemovedFromFavourites}`,
    );
  },
  getFavouriteFarms: () => {
    return axiosInstance.get(GET_FAVORITE_FARMS_SERVICE_URL);
  },
};

export type FarmsApiType = typeof api;
